/*
  Cart drawer quantity rules, counting every can in the cart:
  - Cart Limit (Max Cans setting, when its toggle is on): plus stops at the limit.
  - Cart Minimum (3 cans): minus stops at a cart total of 3, and a change that
    would leave 1-2 cans empties the cart instead.
*/
(function () {
  'use strict';

  var CART_MINIMUM = 3;

  function drawerInputs(root) {
    return root.querySelectorAll('input.quantity__input[name="updates[]"]');
  }

  function applyMaxCansCartDrawer() {
    var root = document.getElementById('CartDrawer');
    if (!root) return;

    var enabled = window.maxCansEnabled === true;
    var limit = parseInt(String(window.maxCansLimit != null ? window.maxCansLimit : 15), 10) || 15;
    var inputs = drawerInputs(root);

    var totalQty = 0;
    inputs.forEach(function (inp) {
      totalQty += parseInt(inp.value, 10) || 0;
    });

    inputs.forEach(function (input) {
      var lineQty = parseInt(input.value, 10) || 0;

      // Each line may drop by however many cans the cart holds above the minimum.
      var floorFromCart = lineQty - Math.max(0, totalQty - CART_MINIMUM);
      input.setAttribute('min', String(Math.max(0, floorFromCart)));

      var ruleMax = input.getAttribute('data-ctr-qty-rule-max');
      if (!enabled) {
        if (ruleMax !== null && ruleMax !== '') {
          input.setAttribute('max', ruleMax);
        } else {
          input.removeAttribute('max');
        }
        return;
      }
      var variantMax = ruleMax === null || ruleMax === '' ? Infinity : parseInt(ruleMax, 10);
      var room = limit - totalQty;
      var ceilingFromCart = lineQty + Math.max(0, room);
      var effectiveMax = Math.min(variantMax, ceilingFromCart);
      input.setAttribute('max', String(effectiveMax));
    });

    publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
  }

  window.applyMaxCansCartDrawer = applyMaxCansCartDrawer;

  // A drawer change (remove, typed quantity, upgrade buttons) that would leave
  // 1-2 cans first sets every other line to 0, then lets the theme remove the
  // remaining line so it re-renders the now empty drawer as usual.
  if (typeof CartItems !== 'undefined') {
    var updateQuantity = CartItems.prototype.updateQuantity;
    CartItems.prototype.updateQuantity = function (line, quantity, name, variantId) {
      if (this.tagName !== 'CART-DRAWER-ITEMS') return updateQuantity.apply(this, arguments);

      // Quantities by cart line (data-index is 1-based), as rendered.
      var lineQtys = [];
      drawerInputs(this).forEach(function (input) {
        lineQtys[parseInt(input.dataset.index, 10) - 1] = parseInt(input.getAttribute('value'), 10) || 0;
      });
      var lineIndex = parseInt(line, 10) - 1;
      var lineQty = lineQtys[lineIndex];
      var cartTotal = lineQtys.reduce(function (sum, qty) {
        return sum + (qty || 0);
      }, 0);
      var resultingTotal = cartTotal - (lineQty || 0) + (parseInt(quantity, 10) || 0);
      var dropsBelowMinimum = resultingTotal > 0 && resultingTotal < CART_MINIMUM && resultingTotal < cartTotal;
      if (lineQty === undefined || !dropsBelowMinimum) {
        return updateQuantity.apply(this, arguments);
      }

      var self = this;
      var updates = [];
      for (var i = 0; i < lineQtys.length; i++) updates.push(i === lineIndex ? lineQty : 0);
      var config = fetchConfig();
      config.body = JSON.stringify({ updates: updates });
      this.enableLoading(line);
      fetch(routes.cart_update_url, config)
        .then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          // Only the changed line is left, so it is now line 1 (Dawn's lines are 1-based).
          updateQuantity.call(self, 1, 0, name, variantId);
        })
        .catch(function () {
          self.disableLoading(line);
          var input = self.querySelector('input.quantity__input[data-index="' + line + '"]');
          if (input) input.value = input.getAttribute('value');
          var errors = document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = window.cartStrings.error;
        });
    };
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    if (document.getElementById('CartDrawer')) {
      applyMaxCansCartDrawer();
    }
  });

  document.addEventListener('DOMContentLoaded', applyMaxCansCartDrawer);
})();
